<template>
    <div class="setting-advanced-tag">
        <div class="module-item-style">
            <div class="module-item-title">会话屏蔽网站列表</div>
            <div class="module-item-tips">通过设置会话屏蔽网站 ，客服在发送消息给访客时，会监控客服发送的消息中是否带有屏蔽网站中包含的网站。如果包含了网站的链接，消息会发送失败。</div>
            <div class="tag-add-btn">
                <div class="wl-btn" @click="addWebsite"><i class="el-icon-plus"></i>添加屏蔽网站</div>
            </div>
            <div class="table-box">
                <tableMulti
                    :tableData="tableData"
                    :tableHead="tableHead"
					:isLoading="isloading"
                    :tableHandler="tableHandler"
                    :total="total"
                    :size="pageSize"
                    @handleButton="handleOperate"
                    @pageHandler="pageOperate"></tableMulti>
            </div>
        </div>
        <el-dialog
                :title="dialogTitle"
                width="450px"
                class="tag-dialog"
                :visible.sync="dialogFormVisible">
            <div class="tag-content-container">
                <el-input v-model="websiteForm.externalLink" placeholder="请输入屏蔽网站"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitData">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
	import tableMulti from '@/components/table/table-multi'
    export default {
        name: 'setting-online-whiteList',
		components:{
		  tableMulti
		},
        data() {
            return {
                dialogTitle: '添加屏蔽网站',
                dialogFormVisible: false,
                dialogType: 'add',
				isloading: false,
                websiteForm: {
                    id: '',
					externalLink : ''
                },
                currentPage: 1,
                pageSize: 10,
                tableHandler: [
                    {label: "编辑", type: 'edit', methods: 'editMethods'},
                    {label: "删除", type: 'del', methods: 'delMethods'},
                ],
                tableData: [],
                tableHead: [
                    {
                        label: '屏蔽网站',
                        value: 'externalLink',
                        operate: false
                    }, {
                        label: '操作',
                        value: '',
                        width: '240',
                        operate: true,
                    }
                ],
                total: 0
            }
        },
        created() {
            this.getWebsiteList()
        },
        mounted() {

        },
        methods: {
            handleOperate(val) {
				let delData = []
				if(val.methods == "delMethods"){
				  delData.push(val.row.id)
				  this.delWebsiteList(delData)
				}else if(val.methods == 'delAll'){
				  if(val.row.length == 0){
				    this.$message.warning('请勾选要删除的屏蔽网站')
				    return false
				  }
				  val.row.map((item) => {
				    delData.push(item.id)
				  })
				  this.delWebsiteList(delData)
				} else if(val.methods == 'editMethods') {
					this.dialogType = 'edit'
					this.dialogTitle = '编辑屏蔽网站'
					this.dialogFormVisible = true
					this.websiteForm.id = val.row.id 
					this.websiteForm.externalLink = val.row.externalLink
				}
            },
			/**
			 *  分页操作
			 * @param val
			 */
			pageOperate(val){
			  if(val.type == 'currentChange'){
			    this.currentPage = val.val
			  }else if(val.type == "sizeChange"){
			    this.pageSize = val.val
			  }
			  this.getWebsiteList()
			},
            addWebsite() {
				if(this.tableData.length == 10){
					this.$message.warning('最多添加10条屏蔽网站')
					return false
				}
                this.dialogType = 'add'
                this.dialogTitle = '添加屏蔽网站'
                this.dialogFormVisible = true
            },
            editWebsite(item) {
                this.tagId = item.tagId
                this.dialogType = 'edit'
                this.dialogTitle = '编辑屏蔽网站'
                this.dialogFormVisible = true
            },
            submitData() {
                if (this.$utils.u_isEmpty(this.websiteForm.externalLink)) {
                    this.$message.error('屏蔽网站名不能为空')
                    return false
                }
				if(this.dialogType == 'add'){
					this.websiteForm.id = null 
				}
				this.$http.saveExternalLinkAPI(this.websiteForm).then(res => {
				    if (res.status == 1) {
				        this.dialogFormVisible = false
						this.websiteForm.externalLink = ''
				        this.$message.success(res.msg)
						this.getWebsiteList()
				    } else {
				        this.$message.error(res.msg)
				    }
				})
            },
			getWebsiteList() {
				this.isloading = true
				this.$http.externalLinkListAPI({
				  pageNum: this.currentPage,
				  pageSize: this.pageSize
				}).then(res => {
				  if (res.status == 1) {
				    this.tableData = res.data
					this.total = res.data.length
				  }
				  this.isloading = false
				}).catch(err => {
				  console.log(err)
				  this.isloading = false
				})
			},
			delWebsiteList(listArr){
			  this.$http.delExternalLinkAPI(listArr).then( res => {
			    if(res.status == 1){
			      this.getWebsiteList()
				  this.$message.success(res.msg)
			    }else {
			      this.$message.error(res.msg)
			    }
			  })
			}
        }
    }
</script>

<style lang="scss">
    
</style>
